import {
	RiAlertLine,
	RiErrorWarningLine,
	RiInformationLine,
} from '@remixicon/react';
import type { ReactNode } from 'react';

import { Card } from '@playbook/atoms/card';
import { Symbol, type SymbolVariant } from '@playbook/atoms/symbol';

import css from './styles.module.css';

export type NoticeVariant = Extract<
	SymbolVariant,
	'information' | 'warning' | 'error'
>;

const NoticeIcons: Record<NoticeVariant, ReactNode> = {
	information: <RiInformationLine />,
	warning: <RiAlertLine />,
	error: <RiErrorWarningLine />,
};

interface NoticeProps {
	variant?: NoticeVariant;

	title: string;
	children: ReactNode;
}

/**
 *	Something the reader has to take in before acting — the private key that
 *	cannot be shown twice, a revocation that cannot be undone.
 *
 *	Playbook has no banner, so this is its two parts composed: the surface is
 *	`atoms/card` and the status comes from `atoms/symbol`. Only the two-column
 *	arrangement is local.
 */
export function Notice({
	variant = 'information',

	title,
	children,
}: NoticeProps): ReactNode {
	return (
		<Card>
			<div className={css.notice}>
				<Symbol variant={variant} rounded icon={NoticeIcons[variant]} />
				<div className={css.body}>
					<strong className={css.title}>{title}</strong>
					<p className={css.copy}>{children}</p>
				</div>
			</div>
		</Card>
	);
}
